import dayjs from 'dayjs';
import { FC, Fragment } from 'react';
import { Comment } from '../../../ types';
import { config } from '../../../../config';
import Button from '../../../ui/Button';
import * as styles from './index.module.scss';
import { Flex } from 'antd';

const CommentCard: FC<Comment> = ({ createdAt, text, fileUrls, author }) => {
  return (
    <div className={styles.comment}>
      <div className={styles.dateBlock}>
        {dayjs(createdAt).format('HH : mm')}
        <span>•</span>
        {dayjs(createdAt).format('MM / DD / YYYY')}
      </div>
      <p className={styles.text}>
        {text.split('\n').map((line, i) => (
          <Fragment key={i}>
            {line}
            <br />
          </Fragment>
        ))}
      </p>
      <Flex align="center" gap={16}>
        {fileUrls.map((url, i) => (
          <Button
            key={i}
            variant="delivery_text"
            icon="arrow_vertical"
            autoWidth
            onClick={() => window.open(`${config.EXTERNAL_ADDRESS}/public/${url}`, '_blank')}
          >
            Фото
          </Button>
        ))}
      </Flex>
      <p className={styles.author}>Автор: {author}</p>
    </div>
  );
};

export default CommentCard;
